import { getTravelText } from "../../components/travelTextTokens";
const DEFAULT_BETH_HABAD_LABEL = "Beth 'Habad";

export function getBethHabadLabel(travel, lang) {
    if (!travel) return DEFAULT_BETH_HABAD_LABEL;

    const localized = lang?.value && travel[lang.value]?.bethHabadLabel;
    const value = (localized || travel.bethHabadLabel || "").trim();

    return getTravelText(travel, "beth_habad_label", value || DEFAULT_BETH_HABAD_LABEL, lang) || value || DEFAULT_BETH_HABAD_LABEL;
}

// ── Distance à pied depuis le Beth Habad ────────────────────────────────────
// Partagé entre hôtels / restaurants / attractions.

export function toNum(v) {
    const n = typeof v === "string" ? parseFloat(v) : v;
    return typeof n === "number" && !Number.isNaN(n) ? n : null;
}

export function haversineMeters(lat1, lon1, lat2, lon2) {
    const R = 6371000;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(a));
}

// Distance "à vol d'oiseau" → minutes à pied (×1.3 détour, ~83 m/min).
export function walkingMinutesFromBirdDistance(meters) {
    const walkingMeters = meters * 1.3;
    return Math.max(1, Math.round(walkingMeters / 83));
}

/**
 * Minutes à pied entre l'org (Beth Habad) et un lieu (avec address.lat/lon),
 * ou null si l'une des coordonnées manque. Tolère lat/long en string.
 */
export function walkMinutesFrom(org, place) {
    const orgLat = toNum(org?.lat);
    const orgLon = toNum(org?.long ?? org?.lon);
    const placeLat = toNum(place?.address?.lat);
    const placeLon = toNum(place?.address?.lon);
    if (orgLat == null || orgLon == null || placeLat == null || placeLon == null) return null;
    return walkingMinutesFromBirdDistance(haversineMeters(orgLat, orgLon, placeLat, placeLon));
}
